import React from "react";
import { Box } from "@mui/material";
import Login from "../Components/LoginComponent/Login";


const LoginPage = () => {
    return (
     
      <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#ffffff",
            padding: "24px",
            boxSizing: "border-box",
            overflow: "hidden",
            fontFamily: "'Inter', sans-serif",
          }}
      >
        <Login />
      </Box>
      
      );
    };
  
  export default LoginPage;